export default "__VITE_ASSET__BdcRKLAY__"